export class Switch {
    label: string;
    labelLeft: boolean;
    input: boolean;
    constructor(label, left, input){
        this.label = label;
        this.labelLeft = left;
        this.input = input;
    }
}